import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Typography } from "@mui/material";
import { useState } from "react";
import PageShell from "../../components/PageShell";
import AttendanceHistory from "./LogsTable";
import LeaveHistory from "./LeavesTable";
import { useSubscriptionCapabilities } from "../../hooks/useSubscriptionCapabilities";
import {
  PAGE_TABS_BAR_SX,
  PAGE_TAB_LIST_PROPS,
  TAB_PANEL_SX,
} from "../../utils/pageLayoutStyles";

const AttendancePage = () => {
  const { isPremiumPackage, loading: capabilitiesLoading } =
    useSubscriptionCapabilities();
  const hasAttendanceCapability = isPremiumPackage;

  const [selectedTab, setSelectedTab] = useState("1");

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  if (capabilitiesLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={400}
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!hasAttendanceCapability) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={400}
      >
        <Typography variant="h6" color="error">
          Attendance History is not available in your subscription plan.
        </Typography>
      </Box>
    );
  }

  return (
    <PageShell title="ATTENDANCE">
      <TabContext value={selectedTab}>
        <Box sx={PAGE_TABS_BAR_SX}>
          <TabList {...PAGE_TAB_LIST_PROPS} onChange={handleChange}>
            <Tab label="All Attendance" value="1" />
            <Tab label="All Leaves" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={TAB_PANEL_SX}>
          <AttendanceHistory />
        </TabPanel>
        <TabPanel value="2" sx={TAB_PANEL_SX}>
          <LeaveHistory />
        </TabPanel>
      </TabContext>
    </PageShell>
  );
};

export default AttendancePage;
